
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { ErrorDisplay } from '@/shared/components/ErrorDisplay'

export default function ErrorPage() {
    const routeError = useRouteError()

    const error =
        routeError instanceof Error
            ? { message: routeError.message, statusCode: 500 }
            : isRouteErrorResponse(routeError)
              ? { message: routeError.statusText, statusCode: routeError.status }
              : { message: 'An unexpected error occurred', statusCode: 500 }

    return <ErrorDisplay error={error} reset={() => window.location.reload()} />
}
